var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSmallPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09091 9.49254L1.27273 5.73134L0 6.98507L5.09091 12L16 1.25373L14.7273 0L5.09091 9.49254Z",
    fill: "#572580"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmallPurple);
export default __webpack_public_path__ + "static/media/check-small-purple.94c515c0734e8adcae53dfd995a50717.svg";
export { ForwardRef as ReactComponent };